module.exports = __webpack_public_path__ + "img/information_message_of_love_mob@2x.24727e5.jpg";